module.exports = __webpack_public_path__ + "img/w3_search_dark.81410a47.png";